<template>
  <div class="box">
    <form
      class="sign-up is-centered"
      @submit.prevent="onSubmit"
    >
      <img
        :src="$store.getters['ui/authLogo']"
        alt="logo"
      >

      <h1 class="title is-4 has-text-primary">
        Nueva Contraseña
      </h1>

      <div class="columns is-multiline">
        <div class="column is-12">
          <p class="notification">
            Bienvenido {{ name }}. <br>
            Ingresa tu nueva contraseña.
          </p>
        </div>

        <div class="column is-12-mobile is-12-fullhd is-6">
          <AppInputPassword
            :value="password"
            :disabled="loading"
            required
            @input="onChange"
            @change="onChange"
          />
        </div>

        <div class="column is-12-mobile is-12-fullhd is-6">
          <AppInputPassword
            id="passwordConfirmation"
            name="passwordConfirmation"
            label="Repetir Contraseña"
            error-message="Las contraseñas no coinciden"
            :value="passwordConfirmation"
            :pattern="password"
            :disabled="loading"
            required
            @input="onChange"
            @change="onChange"
          />
        </div>
      </div>

      <ButtonSubmit
        :loading="loading"
        :disabled="loading"
        text="guardar contraseña"
      />
    </form>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapMutations, mapActions } = createNamespacedHelpers('auth');

export default {
  name: 'PasswordRecovery',
  components: {
    AppInputPassword: () => import(/* webpackChunkName: "app-input-password" */ '@/components/AppInputPassword.vue'),
    ButtonSubmit: () => import(/* webpackChunkName: "auth-button-submit" */ '@/components/Auth/ButtonSubmit.vue'),
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapState({
      name: state => state.name,
      password: state => state.password,
      passwordConfirmation: state => state.passwordConfirmation,
    }),
  },
  beforeRouteEnter(to, from, next) {
    if (!to.query.token) next({ name: 'Landing' });
    else next();
  },
  async beforeMount() {
    this.loading = true;
    try {
      await this.verifyPasswordRecovery(this.$route.query.token);
    } catch (error) {
      this.$store.dispatch('addTemporalNotification', {
        type: 'danger',
        content: 'Token de recuperación de contraseña invalido.',
      });
      this.$router.replace({ name: 'Landing' });
    }
    this.loading = false;
  },
  beforeDestroy() {
    this.cleanSensitiveData();
  },
  methods: {
    ...mapMutations([
      'setValue',
      'cleanSensitiveData',
    ]),
    ...mapActions([
      'passwordRecovery',
      'verifyPasswordRecovery',
      'initAuthentication',
    ]),
    onChange(event) {
      const { name: accessor, value } = event.target;
      this.setValue({ accessor, value });
    },
    async onSubmit() {
      this.loading = true;
      try {
        await this.passwordRecovery(this.$route.query.token);

        this.$store.dispatch('addTemporalNotification', {
          type: 'success',
          content: 'Contraseña guardada exitosamente.',
        });

        this.$router.replace({ name: 'Home' });
      } catch (error) {
        this.$store.dispatch('addTemporalNotification', {
          type: 'danger',
          content: error.message,
        });
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.submit-button {
  margin-top: 1rem;
}

.box {
  padding: 3rem;
}

@media screen and (min-width: 769px) {
  form {
    max-width: 600px;
  }
}

img {
  width: 300px;
  height: auto;
  padding: 1rem 0;
}
</style>
